import { terminoParaFiltro, columnaNormalizada } from '../utils/normalizacionBusqueda';
import { supabase } from './supabase';
import { callMcpTool } from './mcpClient';

/**
 * Frontend service for tool_categories (#91).
 * Direct Supabase queries for read; MCP endpoint for admin writes so the
 * audit log fires server-side.
 */

export const listToolCategories = async ({ active_only = true, search } = {}) => {
  try {
    let q = supabase
      .from('tool_categories')
      .select('*')
      .order('label_es', { ascending: true });
    if (active_only) q = q.eq('active', true);
    if (search) {
  // #742/#739 — `label_es` y `label_en` son texto humano y van contra sus
    // `*_norm`; `slug` es un identificador y se queda crudo. El mismo termino
    // sirve para los tres: el ILIKE ya es insensible a mayusculas.
    const s = `%${terminoParaFiltro(search)}%`;
      q = q.or(`slug.ilike.${s},${columnaNormalizada('label_es')}.ilike.${s},${columnaNormalizada('label_en')}.ilike.${s}`);
    }
    const { data, error } = await q;
    return { data: data || [], error };
  } catch (error) {
    return { data: [], error };
  }
};

export const createToolCategory = async ({ slug, label_es, label_en, icon }) =>
  callMcpTool('create_tool_category', { slug, label_es, label_en: label_en || null, icon: icon || null });

export const updateToolCategory = async ({ category_id, label_es, label_en, icon, active }) => {
  const payload = { category_id };
  if (label_es !== undefined) payload.label_es = label_es;
  if (label_en !== undefined) payload.label_en = label_en;
  if (icon !== undefined) payload.icon = icon;
  if (active !== undefined) payload.active = active;
  return callMcpTool('update_tool_category', payload);
};
